import GQLRequest from 'utils/GQLRequest';

export interface ExportAllRequest {
  projectid: string;
  drawings: boolean;
  punch: boolean;
  rfis: boolean;
  submittals: boolean;
  userlog: boolean;
}

export const exportAllData = async (
  projectid: string,
  drawings: boolean,
  punch: boolean,
  rfis: boolean,
  submittals: boolean,
  users: boolean
): Promise<string> => {
  const input: ExportAllRequest = {
    projectid,
    drawings,
    punch,
    rfis,
    submittals,
    userlog: users,
  };

  const { exportAllData: exportAll } = await new GQLRequest()
    .query(
      `
      query ExportAllData($input: ExportAllRequest!) {
        exportAllData(input: $input) {
          extension
          url
        }
    }
      `
    )
    .variables({
      input,
    })
    .json<{ exportAllData: string }>();

  return exportAll;
};
